import {
  ButtonGroup,
  List,
  ListItem,
  LegacyModal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTrigger,
  PrimaryButton,
  Text,
  Link,
} from "@certn/cascadia-react";
import { weights } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { Trans, useTranslation } from "react-i18next";

export function PurposeInfoModal() {
  const { t } = useTranslation();

  return (
    <ModalTrigger
      trigger={() => (
        <Link
          textStyle="global/body-secondary"
          textColor="text-info"
          testID="purpose-of-check-whats-this-button"
        >
          <Trans>What's this?</Trans>
        </Link>
      )}
    >
      {(close) => (
        <LegacyModal>
          <ModalHeader close={close} title={t("Purpose of check")} />
          <ModalContent>
            <Text style="global/body-primary">
              <Trans>
                <strong className={styles.highlight}>Employment</strong> should
                be selected if you need this for:
              </Trans>
            </Text>
            <br />
            <br />
            <List type="unordered">
              <ListItem>
                <Trans>Paid employment</Trans>
              </ListItem>

              <ListItem>
                <Trans>Paid contract work</Trans>
              </ListItem>
            </List>
            <br />
            <Text style="global/body-primary">
              <Trans>
                <strong className={styles.highlight}>Licence</strong> should be
                selected if you need this check for licensing or industry
                accreditation, e.g.:
              </Trans>
            </Text>
            <br />
            <br />
            <List type="unordered">
              <ListItem>
                <Trans>Approved managers licence</Trans>
              </ListItem>

              <ListItem>
                <Trans>Real estate licence</Trans>
              </ListItem>

              <ListItem>
                <Trans>Racing licence</Trans>
              </ListItem>
            </List>
            <br />
            <Text style="global/body-primary">
              <Trans>
                <strong className={styles.highlight}>
                  Other (Position of Trust/Probity)
                </strong>{" "}
                should be selected if you need this check for a purpose other
                than employment or licensing, e.g.:
              </Trans>
            </Text>
            <br />
            <br />
            <List type="unordered">
              <ListItem>
                <Trans>House / pet sitter</Trans>
              </ListItem>

              <ListItem>
                <Trans>Board member</Trans>
              </ListItem>

              <ListItem>
                <Trans>Insurance claim</Trans>
              </ListItem>
            </List>
          </ModalContent>
          <ModalFooter>
            <ButtonGroup>
              <PrimaryButton onPress={close} size="medium">
                <Trans>Ok</Trans>
              </PrimaryButton>
            </ButtonGroup>
          </ModalFooter>
        </LegacyModal>
      )}
    </ModalTrigger>
  );
}

const styles = {
  highlight: css({ fontWeight: weights["font-weight-medium"] }),
};
